export enum QuestionDifficultyLevel {
    Easy = 1, //Default
    Medium = 2,
    Hard = 3
}
